import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { UserProvider } from "./features/UserPanel/userContext/UserContext";
import { AdminProvider } from "./features/AdminPanel/context/AdminContext";
import { captureAcquisitionFromUrl } from "./utils/acquisitionTracking";
import { captureMetaClickParams } from "./utils/metaParamBuilder";

captureAcquisitionFromUrl();
captureMetaClickParams();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <AdminProvider>
        <App />
      </AdminProvider>
    </UserProvider>
  </React.StrictMode>
);
